import script from "./session-item.vue?vue&type=script&setup=true&lang=js"
export * from "./session-item.vue?vue&type=script&setup=true&lang=js"

import "./session-item.vue?vue&type=style&index=0&id=dface286&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dface286"]])

export default __exports__